import { generateVuexCrud, multipleEntityRequest } from '@/utilities/crud/vuex';

const crudOptions = {
    single: 'amazonProductCategory',
    multiple: 'amazonProductCategories',
    endpoint: 'amazonProductCategories',
};

const crud = generateVuexCrud(crudOptions);

const state = {
    ...crud.state,
};

const actions = {
    ...crud.actions,

    getAmazonProductCategories(store, { page, sortBy, direction, search, parent_id } = {}) {
        return multipleEntityRequest(crudOptions, { params: { page, sortBy, direction, search, parent_id } });
    },
};

const mutations = {
    ...crud.mutations,
};

export default {
    state,
    actions,
    mutations,
};
